import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=254f7548&"
import script from "./Vacancy.vue?vue&type=script&lang=js&"
export * from "./Vacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports